<template>
  <div v-if="showPopup" class="popFixed">
    <div class="masking" @click="closePopup" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>请先完善填写您的证件号再提交文件，否则无法完成绑定</p>
      </div>
      <div class="btnCon">
        <span style="font-weight: bold" @click="goToAccUpdatePersonalData">去添加</span>
        <span style="color: #333; font-weight: normal" @click="cancel">取消</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdentityUpdatePersonalDataPopup',
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      showPopup: this.show
    }
  },
  watch: {
    show: function(newVal) {
      this.showPopup = newVal
    }
  },
  methods: {
    cancel() {
      this.closePopup()
    },
    goToAccUpdatePersonalData() {
      this.$router.push({ path: '/home/accUpdatePersonalData', query: { from: this.$route.path }})
    },
    closePopup() {
      this.showPopup = false
      this.$emit('onClose')
    }
  }
}
</script>
